export default "__VITE_ASSET__LwG0iIa___"